// extracted by mini-css-extract-plugin
module.exports = {"overflow":"styles-module__overflow___Mf1BK","overflowitem":"styles-module__overflowitem___1u9EU"};